


































































































import { TaxaCanalVendaPlug4market, CanalVendaMarketplace } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { maiorQueZero, obrigatorio } from '@/shareds/regras-de-form'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import SeletorDeCanalDeVendaMarketplace from './SeletorDeCanalDeVendaMarketplace.vue'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import type { MarketplaceServiceAdapter } from '@/usecases'

@Component({
	components: {
		SeletorDeCanalDeVendaMarketplace,
		Confirmacao,
	},
})
export default class DialogoDeTaxasCanalVendaMarketplace extends Vue {
	@Ref() formulario!: HTMLFormElement
	@Ref() confirmacaoDeDeletar!: Confirmacao
	@Ref() confirmacaoDeAplicarAosProdutos!: Confirmacao
	@Ref() seletorDeCanal!: SeletorDeCanalDeVendaMarketplace

	@Prop({ required: true })
	marketplaceService!: MarketplaceServiceAdapter

	mostra = false
	carregando = false
	salvando = false
	deletando: string | null = null
	configuracaoId: string | null = null
	taxas: TaxaCanalVendaPlug4market[] = []
	busca = ''

	get taxasFiltradas() {
		if (!this.busca) return this.taxas
		const termo = this.busca.toLowerCase()
		return this.taxas.filter(t => t.nomeCanalVenda?.toLowerCase().includes(termo))
	}

	taxaEmEdicao: { id: string | null; canal: CanalVendaMarketplace | null; percentual: number | null } = {
		id: null,
		canal: null,
		percentual: null,
	}

	obrigatorio = obrigatorio
	maiorQueZero = maiorQueZero

	cabecalhos = [
		{ text: 'Canal de Venda', value: 'nomeCanalVenda', sortable: false },
		{ text: 'Percentual', value: 'percentual', sortable: false },
		{ text: 'Ações', value: 'acoes', sortable: false, align: 'end' },
	]

	async mostrar(configuracaoId: string) {
		this.configuracaoId = configuracaoId
		this.mostra = true
		await this.carregar()
	}

	async carregar() {
		if (!this.configuracaoId) return
		this.carregando = true
		try {
			this.taxas = await this.marketplaceService.buscarTaxasCanaisVenda(this.configuracaoId)
			this.$nextTick(() => this.sincronizarCanaisJaCadastrados())
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.carregando = false
		}
	}

	sincronizarCanaisJaCadastrados(idEmEdicao: string | null = null) {
		if (!this.seletorDeCanal) return
		this.seletorDeCanal.canaisJaCadastrados = this.taxas
			.filter(t => t.id !== idEmEdicao && t.canalVendaPlug4marketCodigo)
			.map(t => ({ codigo: t.canalVendaPlug4marketCodigo!, nome: t.nomeCanalVenda || '', tipo: '' }))
	}

	iniciarEdicao(taxa: TaxaCanalVendaPlug4market) {
		this.taxaEmEdicao = {
			id: taxa.id,
			canal: taxa.canalVendaPlug4marketCodigo
				? { codigo: taxa.canalVendaPlug4marketCodigo, nome: taxa.nomeCanalVenda || '', tipo: '' }
				: null,
			percentual: taxa.percentual,
		}
		this.$nextTick(() => this.sincronizarCanaisJaCadastrados(taxa.id))
	}

	cancelarEdicao() {
		this.taxaEmEdicao = { id: null, canal: null, percentual: null }
		this.formulario?.reset()
		this.$nextTick(() => this.sincronizarCanaisJaCadastrados())
	}

	async salvar() {
		if (!this.formulario.validate()) return
		if (!this.configuracaoId) return

		const payload: TaxaCanalVendaPlug4market = {
			id: this.taxaEmEdicao.id,
			configuracaoPlug4marketId: this.configuracaoId,
			canalVendaPlug4marketCodigo: this.taxaEmEdicao.canal?.codigo || null,
			nomeCanalVenda: this.taxaEmEdicao.canal?.nome || null,
			percentual: this.taxaEmEdicao.percentual,
		}

		this.salvando = true
		let taxaSalvaId: string | null = null
		try {
			if (this.taxaEmEdicao.id) {
				const atualizada = await this.marketplaceService.atualizarTaxaCanalVenda(
					this.configuracaoId,
					this.taxaEmEdicao.id,
					payload,
				)
				const idx = this.taxas.findIndex(t => t.id === atualizada.id)
				if (idx >= 0) this.taxas.splice(idx, 1, atualizada)
				AlertModule.setSuccess('Taxa atualizada com sucesso')
				taxaSalvaId = atualizada.id
			} else {
				const criada = await this.marketplaceService.criarTaxaCanalVenda(this.configuracaoId, payload)
				this.taxas.push(criada)
				AlertModule.setSuccess('Taxa adicionada com sucesso')
				taxaSalvaId = criada.id
			}
			this.cancelarEdicao()
		} catch (e) {
			AlertModule.setError(e)
			return
		} finally {
			this.salvando = false
		}

		if (taxaSalvaId && this.configuracaoId) {
			const aplicar = await this.confirmacaoDeAplicarAosProdutos.mostrar()
			if (aplicar) {
				await this.aplicarTaxaAosProdutos(taxaSalvaId)
			}
		}
	}

	async aplicarTaxaAosProdutos(taxaId: string) {
		if (!this.configuracaoId) return
		try {
			await this.marketplaceService.aplicarTaxaAosProdutos(this.configuracaoId, taxaId)
			AlertModule.setSuccess('Taxa aplicada aos produtos com sucesso')
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async deletar(taxa: TaxaCanalVendaPlug4market) {
		if (!this.configuracaoId || !taxa.id) return
		const confirmado = await this.confirmacaoDeDeletar.mostrar()
		if (!confirmado) return
		this.deletando = taxa.id
		try {
			await this.marketplaceService.deletarTaxaCanalVenda(this.configuracaoId, taxa.id)
			this.taxas = this.taxas.filter(t => t.id !== taxa.id)
			this.$nextTick(() => this.sincronizarCanaisJaCadastrados())
			AlertModule.setSuccess('Taxa removida com sucesso')
		} catch (e) {
			AlertModule.setError(e)
		} finally {
			this.deletando = null
		}
	}

	fechar() {
		this.mostra = false
		this.cancelarEdicao()
		this.taxas = []
		this.configuracaoId = null
	}
}
